import { BrandTypes } from './actionTypes';

export const getBrand = () => {
  return {
    type: BrandTypes.GET_BRAND,
  };
};

export const getBrandSuccess = (payload: any) => {
  return {
    type: BrandTypes.GET_BRAND_SUCCESS,
    payload,
  };
};

export const getBrandFailed = (payload: any) => {
  return {
    type: BrandTypes.GET_BRAND_FAILED,
    payload,
  };
};

export const getBrandByNetwork = (payload: any) => {
  return {
    type: BrandTypes.GET_BRAND_BY_NETWORK,
    payload,
  };
};

export const getBrandByNetworkSuccess = (payload: any) => {
  return {
    type: BrandTypes.GET_BRAND_BY_NETWORK_SUCCESS,
    payload,
  };
};

export const getBrandByNetworkFailed = (payload: any) => {
  return {
    type: BrandTypes.GET_BRAND_BY_NETWORK_FAILED,
    payload,
  };
};
